// Copyright (c) 2020 Deere & Company

import t from 'tcomb';

const Favorite = t.struct({
    id: t.String,
    route: t.String
}, {
    name: 'Favorite',
    strict: true
});

export const getDefaultState = () => new Favorite({
    id: '',
    route: ''
});

export default Favorite;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/favorite.js